import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { isInFlight } from '@core/betting/freebetInteractionControls'
import { PANELS } from '@constants/bettingConstants'
import {
  selectRequestedFreebetId,
  selectFreebetList,
  selectFreebetPanel,
  selectFreebet,
  clearFreebetSelectionRequest,
} from '@slices/bettingSlice'

/**
 * Consumes a menu "Play" request: selects the freebet on panel one once the
 * betting list contains it and panel one is free, then clears the request. Kept
 * out of the controller so any freebet layout opts in by calling this hook. Play
 * is disabled when busy / already-shown, so this only ever waits for the list.
 */
export const useFreebetSelectionRequest = () => {
  const dispatch = useDispatch()
  const requestedFreebetId = useSelector(selectRequestedFreebetId)
  const list = useSelector(selectFreebetList)
  const panelOne = useSelector(selectFreebetPanel(PANELS.ONE))

  useEffect(() => {
    if (requestedFreebetId == null) return
    if (isInFlight(panelOne.betState)) return
    if (!list.some((fb) => fb.id === requestedFreebetId)) return // wait for the list
    dispatch(selectFreebet({ panel: PANELS.ONE, id: requestedFreebetId }))
    dispatch(clearFreebetSelectionRequest())
  }, [requestedFreebetId, list, panelOne.betState, dispatch])
}
